/**
 * @function getQueryParams
 * @desc parses the query parameters of an URL.
 *
 * @param {String} url : url to parse
 *
 * @returns {Object} key-value pairs of query params
 */
const getQueryParams = (
  url: string | null
): Record<string, string | boolean> | null => {
  if (typeof url !== 'string') return null;

  const queryStart = url.indexOf('?');

  if (queryStart >= 0) {
    const queryParams: Record<string, string | boolean> = {};
    const queryString: string = url.substring(queryStart + 1);
    const keyValuePairs = queryString.split('&');
    let l: number = keyValuePairs.length;
    if (l !== undefined && typeof l === 'number' && l > 0) {
      while (l > 0) {
        l--;
        const keyValues = keyValuePairs[l].split('=');
        const key = keyValues[0];
        if (key === '') return null;

        const value = (() => {
          switch (keyValues[1]) {
            case 'false':
              return false;
            case 'true':
              return true;
            case undefined:
              return true;
            default:
              return decodeURI(keyValues[1]);
          }
        })();

        queryParams[key] = value;
      }
    }
    if (Object.keys(queryParams).length > 0) return queryParams;
  }

  return null;
};

export default getQueryParams;
